import React, { FC } from 'react'
import { IRouteProps } from '../../types/routes'
import { Route } from 'react-router'
import { AppContainer } from './styled'

const PublicRoute: FC<IRouteProps> = ({
	component: Component,
	...rest
}: IRouteProps) => {
	return (
		<AppContainer>
			<Route {...rest} render={props => <Component {...props} />} />
		</AppContainer>
	)
}

export default PublicRoute
